import React from "react";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import Bredcrumb from "../components/Bredcrumb";
import GptContent from "../components/GptPages/GptContent";
import CustomHelmet from "../components/CustomHelmet";
const HomeScreen = styled.div``;

const Gpt = () => {
  return (
    <>
      <CustomHelmet
        title="Revolutionizing Education with AI Mentors: Our Vision for GPTs"
        description="Arcaptor harnesses AI to create specialized GPTs—24x7 intelligent mentors tailored to specific exams—guiding students, addressing queries, and transforming education."
      />
      <MainLayout>
        <HomeScreen>
          <Bredcrumb
            heading="AI is revolutionizing education with platforms like SSB-GPT, NDA-GPT, and beyond!"
            subHeading="#NDAGPT"
            subHeading2="#SSBGPT"
            subHeading3="#AFCATGPT"
            link=""
            image="./images/gptImage.png"
            imgStyleHeight="500px"
          />
          <GptContent />
        </HomeScreen>
      </MainLayout>
    </>
  );
};

export default Gpt;
